/*
 * Exclusive, animated accordion for .pfc-moulding__details panels (moulding
 * shell on frame hubs + moulding PDPs, pfc-print-product, pfc-mount-product).
 * Opening one row smoothly closes the others. Animates the <details> height
 * between its summary height and its full height, so body padding needs no
 * special handling. Without JS the rows still work as plain <details>.
 */
(function () {
  var DURATION = 280;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function animateTo(d, open) {
    var summary = d.querySelector('summary');
    var start = d.offsetHeight;
    d._pfcTarget = open;
    if (d._pfcAnim) { d._pfcAnim.cancel(); d._pfcAnim = null; }
    if (open) d.open = true;
    var end = open ? d.offsetHeight : summary.offsetHeight;
    if ((reduce && reduce.matches) || !d.animate || start === end) {
      d.open = open;
      return;
    }
    d.style.overflow = 'hidden';
    var anim = d.animate(
      [{ height: start + 'px' }, { height: end + 'px' }],
      { duration: DURATION, easing: 'cubic-bezier(.2,.7,.3,1)' }
    );
    d._pfcAnim = anim;
    anim.onfinish = function () {
      d._pfcAnim = null;
      d.open = open;
      d.style.overflow = '';
    };
    anim.oncancel = function () { d.style.overflow = ''; };
  }

  function init(group) {
    if (group.dataset.pfcAccordion) return;
    group.dataset.pfcAccordion = '1';
    var rows = Array.prototype.slice.call(group.querySelectorAll(':scope > details'));
    rows.forEach(function (d) {
      var summary = d.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        // A row mid-close still reports open, so go by where it is heading.
        var willOpen = !(d._pfcAnim ? d._pfcTarget : d.open);
        if (willOpen) {
          rows.forEach(function (o) { if (o !== d && o.open) animateTo(o, false); });
        }
        animateTo(d, willOpen);
      });
    });
  }

  function boot() {
    document.querySelectorAll('.pfc-moulding__details').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
